<script setup lang="ts">
const { isDesktop } = useResponsive()

const text = computed(() => {
  return isDesktop.value
    ? 'Доступно в&nbsp;AppStore, Google Play, AppGallery, RuStore'
    : 'Приложение доступно в&nbsp;AppStore, Google Play, AppGallery, RuStore'
})
</script>

<template>
  <div class="footer-links-app">
    <div v-if="isDesktop" class="footer-links-app__title">
      Приложение Farfor
    </div>

    <div class="footer-links-app__subtitle" v-html="text" />

    <the-button
      class="footer-links-app__button"
      href="https://farfor.ru/a/"
      variant="white"
      color="secondary"
      rel="nofollow"
      block
    >
      Скачать приложение
    </the-button>

    <div v-if="isDesktop" class="footer-links-app__text">
      Наведите камеру на&nbsp;QR-код, чтобы скачать приложение
    </div>

    <nuxt-img
      v-if="isDesktop"
      class="footer-links-app__image"
      src="/footer/footer-app-qr.svg"
      width="64"
      height="64"
      alt="Наведите камеру на QR-код, чтобы скачать"
      loading="lazy"
    />
  </div>
</template>

<style scoped lang="scss">
.footer-links-app {
  &__title {
    @include media('>=desktop-mini') {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 800;
      line-height: 20px;
      color: var(--ui-text-primary);
    }
  }

  &__subtitle {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--ui-text-primary);
    letter-spacing: -0.01em;

    @include media('>=desktop-mini') {
      margin-bottom: 14px;
      color: var(--ui-text-secondary);
    }
  }

  &__button {
    @include media('>=desktop-mini') {
      margin-bottom: 20px;
    }
  }

  &__text {
    @include media('>=desktop-mini') {
      max-width: 200px;
      margin-bottom: 14px;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: var(--ui-text-secondary);
      letter-spacing: -0.01em;
    }
  }

  &__image {
    display: block;
  }
}
</style>
